module.exports = __webpack_public_path__ + "static/img/myDispear.90e925ef.png";